import { TextField, VariantType, TextFieldProps } from '@entur/form';
import { Badge } from '@entur/layout';
import React from 'react';
import styles from './styles.module.scss';

interface ClearTextFieldProps extends TextFieldProps {
  candidateFilter?: boolean;
  orderId?: boolean;
  reportTemplate?: boolean;
  variant?: VariantType;
  labelClass?: string;
  email?: boolean;
  hasDrawer?: () => void;
}

/**
 * @deprecated Use `components/TextField` instead.
 */
const ClearTextField = React.forwardRef(
  (
    {
      value,
      onChange = () => {},
      orderId = false,
      candidateFilter = false,
      onKeyPress,
      hasDrawer,
      email = false,
      labelClass,
      reportTemplate = false,
      onClick,
      ...rest
    }: ClearTextFieldProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const validateString = (v: React.ChangeEvent<HTMLInputElement>) => {
      if (candidateFilter) {
        onChange(v);
      } else if (email) {
        if (/^[a-zA-Z0-9.@!#$%&'*+/=?^_`{|}~-]+$/g.test(v.target.value) || v.target.value.length === 0) {
          onChange(v);
        }
      } else if (reportTemplate) {
        if (/^[A-Za-z0-9-_. ]*$/.test(v.target.value) || v.target.value.length === 0) {
          onChange(v);
        }
      } else if (orderId) {
        if (/^[A-Za-z0-9 ]*$/.test(v.target.value) || v.target.value.length === 0) {
          v.target.value = v.target.value.toUpperCase();
          onChange(v);
        }
      } else {
        onChange(v);
      }
    };

    const formatLineBreaks = () => {
      if (typeof value === 'string') {
        return value?.replaceAll('\r\n', ', ');
      }
    };

    return (
      <div className={styles.field}>
        <TextField
          ref={ref}
          onKeyDown={onKeyPress}
          value={formatLineBreaks()}
          onChange={(v) => validateString(v)}
          className={labelClass}
          disableLabelAnimation
          onClick={onClick}
          {...rest}
        />
        {hasDrawer && (
          <div className={styles.icon}>
            <Badge variant="info" type="notification" onClick={hasDrawer}>
              i
            </Badge>
          </div>
        )}
      </div>
    );
  }
);

export default ClearTextField;
